import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { useGlobalContext } from "../../GlobalContext";
import LoadingScreen from "../Utils/LoadingScreen";
import ViewBanner from "./ViewBanner";
import {
  Send,
  Loader2,
  FileText,
  Clock,
  Package,
  Megaphone,
  Pencil,
  User,
  MessageSquare,
  Image,
  Plus,
  RotateCcw,
  Sparkles,
  Search,
  ChevronDown,
  CheckCircle2,
  X,
} from "lucide-react";
import useNotification from "../../Sevices/useNotification";
import NotificationHistory from "./NotificationHistory";
import useDriver from "../../Sevices/Driver Api/useDriver";

export default function Notification() {
const { AdminId, clearNotificationCount } = useGlobalContext();
  const {
    sendNotification,
    loadingDrivers,
    sending,
    baseurl,
    token,
    setIsUnauthorised,
  } = useNotification();

   const {
        drivers,
        loading,
        fetchDrivers,
      } = useDriver();

  const [activeTab, setActiveTab] = useState("history");
  const [showTemplates, setShowTemplates] = useState(true);
  const [driverSearch, setDriverSearch] = useState("");
const [driverDropdownOpen, setDriverDropdownOpen] = useState(false);
  const [autoFilled, setAutoFilled] = useState({ title: false, body: false });
  const [form, setForm] = useState({
    category: "",
    driverId: "",
    title: "",
    body: "",
    image: "",
    extra: "",
    adminId: AdminId,
  });

  const [errors, setErrors] = useState({
    driverId: "",
    title: "",
    body: "",
  });

  const messageCategories = {
    shift: {
      label: "Shift Management",
      icon: <Clock className="inline w-4 h-4 text-blue-600" />,
      color: "blue",
      messages: [
        {
          title: "Shift Reminder",
          body: "Your shift starts in 30 minutes. Please be ready.",
        },
        {
          title: "Shift Started",
          body: "Your shift has started. Go online to receive orders.",
        },
        {
          title: "Shift Ending Soon",
          body: "Your shift ends in 15 minutes. Complete current deliveries.",
        },
        {
          title: "Shift Ended",
          body: "Your shift has ended. Thank you for your service today!",
        },
      ],
    },
    orders: {
      label: "Order & Task Management",
      icon: <Package className="inline w-4 h-4 text-emerald-600" />,
      color: "emerald",
      messages: [
        {
          title: "Urgent Task",
          body: "You have been assigned a new urgent task. Check now.",
        },
        {
          title: "High Priority Order",
          body: "You have a high priority order waiting. Please accept quickly.",
        },
        {
          title: "Order Timeout Warning",
          body: "Please accept or decline the order within 30 seconds.",
        },
        {
          title: "Pickup Reminder",
          body: "Don't forget to pick up order from the restaurant.",
        },
      ],
    },
    general: {
      label: "General Communication",
      icon: <Megaphone className="inline w-4 h-4 text-purple-600" />,
      color: "purple",
      messages: [
        {
          title: "System Maintenance",
          body: "App will be under maintenance from 2-3 AM tonight.",
        },
        {
          title: "New Feature",
          body: "Check out the new photo verification feature in the app!",
        },
        {
          title: "Training Reminder",
          body: "Mandatory safety training session tomorrow at 10 AM.",
        },
        {
          title: "Holiday Notice",
          body: "Special holiday rates apply today. Earn more per delivery!",
        },
      ],
    },
    custom: {
      label: "Custom Message",
      icon: <Pencil className="inline w-4 h-4 text-orange-600" />,
      color: "orange",
      messages: [{ title: "Custom", body: "" }],
    },
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));

    if (name === "title" || name === "body") {
      setAutoFilled((prev) => ({ ...prev, [name]: false }));
    }
  };

  const handleTemplateSelect = (msg) => {
    setForm((prev) => ({
      ...prev,
      title: msg.title,
      body: msg.body,
    }));

    setAutoFilled({ title: true, body: true });
    setShowTemplates(false);

    setTimeout(() => {
      const titleInput = document.querySelector('input[name="title"]');
      const bodyInput = document.querySelector('textarea[name="body"]');
      if (titleInput) titleInput.focus();
      setTimeout(() => {
        if (bodyInput) bodyInput.focus();
      }, 300);
    }, 100);
  };

  const handleCategoryChange = (e) => {
    const { value } = e.target;
    setForm((prev) => ({
      ...prev,
      category: value,
      title: "",
      body: "",
    }));
    setAutoFilled({ title: false, body: false });
    setShowTemplates(true);
  };

  const validateForm = () => {
    let newErrors = {};
    if (!form.driverId) newErrors.driverId = "Driver is required";
    if (!form.title.trim()) newErrors.title = "Title is required";
    if (!form.body.trim()) newErrors.body = "Body is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSendNotification = async () => {
    if (!validateForm()) {
      toast.error("Please fill all required fields.");
      return;
    }

await sendNotification(form, () => {
  setForm({
    category: "",
    driverId: "",
    title: "",
    body: "",
    image: "",
    extra: "",
    adminId: AdminId,
  });

  setDriverSearch("");
  setDriverDropdownOpen(false);
  setAutoFilled({ title: false, body: false });
  setShowTemplates(true);
});
  };

const selectedDriver = drivers.find(
  (driver) => driver.driverId === form.driverId
);

const filteredDrivers = drivers.filter((driver) => {
  const search = driverSearch.trim().toLowerCase();

  if (!search) return true;

  return (
    driver?.fullName?.toLowerCase().includes(search) ||
    driver?.driverId?.toLowerCase().includes(search) ||
    driver?.mobile?.toLowerCase().includes(search) ||
    driver?.phone?.toLowerCase().includes(search)
  );
});


  useEffect(() => {
    fetchDrivers();
  }, []);

useEffect(() => {
  clearNotificationCount();
}, []);

  return (
    <>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div className="p-3 overflow-hidden">
          <div className="flex gap-6 mb-4 border-b">
            <button
              onClick={() => setActiveTab("history")}
              className={`pb-2 transition-all duration-200 ${activeTab === "history"
                ? "border-b-2 border-orange-400 text-orange-400 font-medium"
                : "text-gray-600 hover:text-orange-500"
                }`}
            >
              Notification
            </button>
            <button
              onClick={() => setActiveTab("send")}
              className={`pb-2 transition-all duration-200 ${activeTab === "send"
                ? "border-b-2 border-orange-300 text-orange-400 font-medium"
                : "text-gray-500 hover:text-orange-500"
                }`}
            >
              Send Notification
            </button>



            <button
              onClick={() => setActiveTab("templates")}
              className={`pb-2 flex items-center gap-2 transition-all duration-200 ${activeTab === "templates"
                ? "border-b-2 border-orange-500 text-orange-600 font-medium"
                : "text-gray-600 hover:text-orange-500"
                }`}
            >
              Templates
            </button>

            <button
              onClick={() => {
                setActiveTab("banners");
              }}
              className={`pb-2 flex items-center gap-2 transition-all duration-200 ${activeTab === "banners"
                ? "border-b-2 border-orange-500 text-orange-600 font-medium"
                : "text-gray-600 hover:text-orange-500"
                }`}
            >
              Banners
            </button>
          </div>

          {activeTab === "send" && (
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2 ">
                <div className="bg-white rounded-3xl p-6 shadow-sm border border-gray-200">
                  <h2 className="text-xl font-bold mb-2 text-gray-800 flex items-center justify-between gap-2">
                    <div className="flex items-center gap-2">
                      <MessageSquare className="w-6 h-6 text-orange-600" />
                      Compose Notification
                    </div>

                    <div className="flex gap-4">
                      <button
    onClick={() => {
  setForm({
    driverId: "",
    category: "",
    title: "",
    body: "",
    image: "",
    extra: "",
    adminId: AdminId,
  });

  setDriverSearch("");
  setDriverDropdownOpen(false);
  setAutoFilled({ title: false, body: false });
  setShowTemplates(true);
}}
                        className="flex items-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-2xl transition-all duration-200"
                      >
                        <RotateCcw className="w-4 h-4" />
                        Reset
                      </button>

                      <button
                        onClick={handleSendNotification}
                        disabled={sending}
                        className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-medium rounded-2xl transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg"
                      >
                        {sending ? (
                          <Loader2 className="animate-spin w-4 h-4" />
                        ) : (
                          <Send className="w-4 h-4" />
                        )}
                        {sending ? "Sending..." : "Send Notification"}
                      </button>
                    </div>
                  </h2>

         <div className="mb-4 relative">
  <label className="flex items-center gap-2 text-sm font-semibold mb-3 text-gray-700">
    <User className="w-4 h-4" />
    Select Driver
  </label>

  <div className="relative">
    <button
      type="button"
      onClick={() => setDriverDropdownOpen((prev) => !prev)}
      className={`w-full px-4 py-3 rounded-2xl border-2 bg-white transition-all duration-200 focus:outline-none text-left ${
        errors.driverId
          ? "border-red-300 bg-red-50"
          : driverDropdownOpen
          ? "border-orange-400 ring-2 ring-orange-100 shadow-sm"
          : "border-gray-200 hover:border-orange-300"
      }`}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <div
            className={`w-10 h-10 rounded-2xl flex items-center justify-center shrink-0 ${
              selectedDriver
                ? "bg-orange-100 text-orange-600"
                : "bg-gray-100 text-gray-500"
            }`}
          >
            <User className="w-5 h-5" />
          </div>

          <div className="min-w-0">
            {selectedDriver ? (
              <>
                <p className="text-sm font-semibold text-gray-800 truncate">
                  {selectedDriver.fullName || "Unnamed Driver"}
                </p>
                <p className="text-xs text-gray-500 truncate">
                  {selectedDriver.driverId}
                  {selectedDriver.mobile || selectedDriver.phone
                    ? ` • ${selectedDriver.mobile || selectedDriver.phone}`
                    : ""}
                </p>
              </>
            ) : (
              <>
                <p className="text-sm font-semibold text-gray-700">
                  Choose a driver
                </p>
                <p className="text-xs text-gray-400">
                  Search and select driver
                </p>
              </>
            )}
          </div>
        </div>

        <ChevronDown
          className={`w-5 h-5 text-gray-400 transition-transform duration-200 ${
            driverDropdownOpen ? "rotate-180" : ""
          }`}
        />
      </div>
    </button>

    {selectedDriver && (
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();

          setForm((prev) => ({
            ...prev,
            driverId: "",
            category: "",
            title: "",
            body: "",
            image: "",
            extra: "",
          }));

          setDriverSearch("");
          setAutoFilled({ title: false, body: false });
          setShowTemplates(true);
        }}
        className="absolute right-12 top-1/2 -translate-y-1/2 w-7 h-7 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 flex items-center justify-center transition"
      >
        <X className="w-4 h-4" />
      </button>
    )}

    {driverDropdownOpen && (
      <div className="absolute z-50 mt-2 w-full rounded-3xl border border-gray-200 bg-white shadow-xl overflow-hidden">
        <div className="p-3 border-b border-gray-100 bg-gray-50">
          <div className="relative">
            <Search className="w-4 h-4 text-gray-400 absolute left-4 top-1/2 -translate-y-1/2" />

            <input
              type="text"
              value={driverSearch}
              onChange={(e) => setDriverSearch(e.target.value)}
              placeholder="Search by name, driver ID or mobile..."
              autoFocus
              className="w-full pl-11 pr-4 py-3 rounded-2xl border border-gray-200 bg-white text-sm focus:outline-none focus:border-orange-400 focus:ring-2 focus:ring-orange-100"
            />
          </div>
        </div>

        <div className="max-h-72 overflow-y-auto custom-scrollbar">
          {loadingDrivers ? (
            <div className="flex items-center justify-center gap-2 py-8 text-sm text-gray-500">
              <Loader2 className="w-4 h-4 animate-spin" />
              Loading drivers...
            </div>
          ) : filteredDrivers.length > 0 ? (
            filteredDrivers.map((driver) => {
              const isSelected = form.driverId === driver.driverId;

              return (
                <button
                  key={driver.driverId}
                  type="button"
                  onClick={() => {
                    setForm((prev) => ({
                      ...prev,
                      driverId: driver.driverId,
                      category: "",
                      title: "",
                      body: "",
                      image: "",
                      extra: "",
                    }));

                    setErrors((prev) => ({ ...prev, driverId: "" }));
                    setAutoFilled({ title: false, body: false });
                    setShowTemplates(true);
                    setDriverDropdownOpen(false);
                    setDriverSearch("");
                  }}
                  className={`w-full px-4 py-3 flex items-center justify-between gap-3 text-left transition ${
                    isSelected
                      ? "bg-orange-50"
                      : "bg-white hover:bg-gray-50"
                  }`}
                >
                  <div className="flex items-center gap-3 min-w-0">
                    <div
                      className={`w-10 h-10 rounded-2xl flex items-center justify-center shrink-0 text-sm font-bold ${
                        isSelected
                          ? "bg-orange-500 text-white"
                          : "bg-gray-100 text-gray-600"
                      }`}
                    >
                      {(driver.fullName || "D").charAt(0).toUpperCase()}
                    </div>

                    <div className="min-w-0">
                      <p className="text-sm font-semibold text-gray-800 truncate">
                        {driver.fullName || "Unnamed Driver"}
                      </p>

                      <p className="text-xs text-gray-500 truncate">
                        {driver.driverId}
                        {driver.mobile || driver.phone
                          ? ` • ${driver.mobile || driver.phone}`
                          : ""}
                      </p>
                    </div>
                  </div>

                  {isSelected && (
                    <CheckCircle2 className="w-5 h-5 text-orange-500 shrink-0" />
                  )}
                </button>
              );
            })
          ) : (
            <div className="py-8 text-center">
              <p className="text-sm font-medium text-gray-700">
                No driver found
              </p>
              <p className="text-xs text-gray-400 mt-1">
                Try searching another name or driver ID
              </p>
            </div>
          )}
        </div>
      </div>
    )}
  </div>

  {errors.driverId && (
    <p className="text-red-500 text-sm mt-2 flex items-center gap-1">
      <span className="w-1 h-1 bg-red-500 rounded-full"></span>
      {errors.driverId}
    </p>
  )}
</div>

                  <div className="mb-4">
                    <label className="flex items-center gap-2 text-sm font-semibold mb-3 text-gray-700">
                      <Package className="w-4 h-4" />
                      Message Category
                    </label>
                    <div className="grid grid-cols-4 gap-3">
                      {Object.entries(messageCategories).map(([key, cat]) => (
                        <button
                          key={key}
                          type="button"
                          onClick={() =>
                            handleCategoryChange({ target: { value: key } })
                          }
                          className={`p-4 rounded-2xl border-2 transition-all duration-200 text-left hover:shadow-md ${form.category === key
                            ? "border-orange-400 bg-orange-50 shadow-lg ring-2 ring-orange-200"
                            : "border-gray-200 hover:border-orange-300 hover:bg-orange-25"
                            }`}
                        >
                          <div className="flex items-center gap-2">
                            {cat.icon}
                            <span className="font-medium text-sm">
                              {cat.label}
                            </span>
                          </div>
                        </button>
                      ))}
                    </div>
                  </div>

                  <div className="space-y-4">
                    <div>
                      <label className="flex items-center gap-2 text-sm font-semibold mb-3 text-gray-700">
                        Title
                      </label>
                      <input
                        name="title"
                        value={form.title}
                        onChange={handleChange}
                        placeholder="Enter notification title..."
                        className={`w-full px-4 py-3 rounded-2xl border-2 transition-all duration-300 focus:outline-none focus:ring-2 ${errors.title
                          ? "border-red-300 bg-red-50 focus:ring-red-200 focus:border-red-400"
                          : autoFilled.title
                            ? "border-orange-300 focus:border-orange-500 focus:ring-orange-200 shadow-sm"
                            : "border-gray-200 hover:border-orange-300 focus:border-orange-500 focus:ring-orange-200"
                          }`}
                      />
                      {errors.title && (
                        <p className="text-red-500 text-sm mt-2 flex items-center gap-1">
                          <span className="w-1 h-1 bg-red-500 rounded-full"></span>
                          {errors.title}
                        </p>
                      )}
                    </div>

                    <div>
                      <label className="flex items-center gap-2 text-sm font-semibold mb-3 text-gray-700">
                        Message Body
                      </label>
                      <textarea
                        name="body"
                        value={form.body}
                        onChange={handleChange}
                        placeholder="Enter your message..."
                        rows="4"
                        className={`w-full px-4 py-3 rounded-2xl border-2 resize-none transition-all duration-300 focus:outline-none focus:ring-2 ${errors.body
                          ? "border-red-300 bg-red-50 focus:ring-red-200 focus:border-red-400"
                          : autoFilled.body
                            ? "border-orange-300 focus:border-orange-500 focus:ring-orange-200 shadow-sm"
                            : "border-gray-200 hover:border-orange-300 focus:border-orange-500 focus:ring-orange-200"
                          }`}
                      />
                      {errors.body && (
                        <p className="text-red-500 text-sm mt-2 flex items-center gap-1">
                          <span className="w-1 h-1 bg-red-500 rounded-full"></span>
                          {errors.body}
                        </p>
                      )}
                    </div>

                    <div className="mb-0">
                      <label className="flex items-center gap-2 text-sm font-semibold mb-3 text-gray-700">
                        <Image className="w-4 h-4" />
                        Image URL{" "}
                        <span className="text-gray-400 font-normal">
                          (Optional)
                        </span>
                      </label>
                      <input
                        name="image"
                        value={form.image}
                        onChange={handleChange}
                        placeholder="https://example.com/image.jpg"
                        className="w-full px-4 py-3 rounded-2xl border-2 border-gray-200 hover:border-orange-300 focus:border-orange-500 focus:outline-none focus:ring-2 focus:ring-orange-200 transition-all duration-200"
                      />
                    </div>

                    <div className="mb-0">
                      <label className="flex items-center gap-2 text-sm font-semibold mb-3 text-gray-700">
                        <Plus className="w-4 h-4" />
                        Extra Data{" "}
                        <span className="text-gray-400 font-normal">
                          (Optional)
                        </span>
                      </label>
                      <input
                        name="extra"
                        value={form.extra}
                        onChange={handleChange}
                        placeholder="Any additional data..."
                        className="w-full px-4 py-3 rounded-2xl border-2 border-gray-200 hover:border-orange-300 focus:border-orange-500 focus:outline-none focus:ring-2 focus:ring-orange-200 transition-all duration-200"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {showTemplates &&
                form.category &&
                messageCategories[form.category]?.messages?.length > 0 && (
                  <div className="lg:col-span-1">
                    <div className="bg-white rounded-3xl p-6 shadow-sm border border-gray-200 sticky top-6">
                      <h3 className="text-lg font-bold mb-4 text-gray-800 flex items-center gap-2">
                        <Sparkles className="w-5 h-5 text-orange-600" />
                        Quick Templates
                      </h3>
                      <div className="space-y-3">
                        {messageCategories[form.category].messages.map(
                          (msg, idx) => (
                            <button
                              key={idx}
                              type="button"
                              onClick={() => handleTemplateSelect(msg)}
                              className="w-full p-4 rounded-2xl border-2 border-gray-200 hover:border-orange-400 hover:bg-orange-50 hover:shadow-md transition-all duration-200 text-left focus:outline-none focus:ring-2 focus:ring-orange-200 focus:border-orange-500"
                            >
                              <p className="font-semibold text-sm text-gray-800 mb-1">
                                {msg.title}
                              </p>
                              <p className="text-xs text-gray-600 line-clamp-2">
                                {msg.body}
                              </p>
                            </button>
                          ),
                        )}
                      </div>
                    </div>
                  </div>
                )}
            </div>
          )}

          {activeTab === "history" && (
            <div className="bg-white rounded-3xl p-6 shadow-sm border border-gray-200">
              <NotificationHistory />
            </div>
          )}

          {activeTab === "templates" && (
            <div className="bg-white rounded-3xl p-12 shadow-sm border border-gray-200 text-center">
              <Sparkles className="w-16 h-16 text-gray-300 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-gray-700 mb-2">
                Templates Coming Soon
              </h3>
              <p className="text-gray-500">
                Advanced templates section is under development
              </p>
            </div>
          )}

          {activeTab === "banners" && (
            <ViewBanner
              baseurl={baseurl}
              token={token}
              setIsUnauthorised={setIsUnauthorised}
            />
          )}
        </div>
      )}
    </>
  );
}
